<div class="glossary-detail-container">
    <div class="card card-block">
        <div *ngIf="glossaryInfo.entry.word && glossaryInfo.entry.id" class="form-group row">
            <div class="card-text ml-1" *ngIf="glossaryInfo.isDefinition"><b>**Currently linked definition in this selection**</b></div>
            <div class="card-text ml-1"><b>Glossary Unique ID: {{glossaryInfo.entry.id}}</b></div>

            <!--<div class="form-check col-md-12">
                <label class="form-check-label" for="addAsDefinition">
                    <input class="form-check-input" type="checkbox" id="addAsDefinition" (click)="addAsDefinition()"  [checked]="glossaryInfo.isDefinition">
                    Make this the definition for the term: "{{glossaryInfo.entry.word}}"</label>

            </div>-->
        </div>

        <!--<div class="form-group row">
            <div class="col-md-12">
                <label class="form-label" for="partOfSpeech">Part of Speech</label>
                <textarea class="form-control" rows="1" cols="55" id="partOfSpeech" [(ngModel)]="glossaryInfo.entry.partOfSpeech.text"></textarea>
            </div>
        </div>-->

        <div class="form-group row">
            <div class="col-md-12">
                <label class="form-label" for="syllables">Syll^.a.bles</label>
                <textarea class="form-control" rows="1" cols="55" id="syllables" [(ngModel)]="glossaryInfo.entry.syllables.text"></textarea>
            </div>
        </div>
        <div class="form-group row">
            <div class="col-md-12">
                <label class="form-label" for="definition">Definition</label>
                <textarea class="form-control" rows="2" cols="55" id="definition" [(ngModel)]="glossaryInfo.entry.definition.text"></textarea>
            </div>
        </div>

        <div class="form-group row">
            <div class="col-md-12">
                <label class="form-label" for="context">Context</label>
                <textarea class="form-control" rows="2" cols="55" id="context" [(ngModel)]="glossaryInfo.entry.context.text"></textarea>
            </div>
        </div>
        <!-- commented out portions reflect UI for multiple languages, not doing for now but leaving in -->
        <!--<div class="card card-outline-warning translationCard">-->
            <!--<div class="card-title">Translations</div>-->

            <div class="col-md-12">
                <div *ngFor="let translation of glossaryInfo.entry.translations; let idx = index" class="form-group row">
                    <!--<div class="col-md-12">{{translation.language}} translation for {{glossaryInfo.entry.word}}</div>-->
                    <!--<div class="col-md-12">
                        <div class="form-group">-->
                            <label for="translation">Translation:</label>
                            <textarea class="form-control" rows="1" cols="55" id="translation" [(ngModel)]="translation.word"></textarea>
                            <label for="language">Language</label>
                            <textarea class="form-control" rows="1" cols="55" id="language" [(ngModel)]="translation.language"></textarea>
                        <!--</div>
                    </div>-->
                    <!--<div class="col-md-12">
                        <div class="btn-group-sm">
                            <button class="btn btn-outline-secondary btn-sm" [disabled]="saveInProgress" (click)="deleteTranslation(translation)">Delete</button>
                        </div>
                    </div>-->
                </div>

                <div *ngIf="showAddTranslation()" class="row">
                    <!--<div class="col-md-12">{{newTranslation.language}} translation for {{glossaryInfo.entry.word}}</div>-->
                    <div class="col-md-12">
                        <div class="form-group">
                            <label class="form-label" for="translation">Translation:</label>
                            <textarea class="form-control" rows="2" cols="55" id="newTranslation" [(ngModel)]="newTranslation.word"></textarea>
                            <label class="form-label" for="newLanguage">Language</label>
                            <textarea class="form-control" rows="2" cols="55" id="newLanguage" [(ngModel)]="newTranslation.language"></textarea>
                        </div>
                    </div>
                    <!--<div class="btn-group-sm">
                        <button class="btn btn-outline-primary btn-sm" [disabled]="saveInProgress" (click)="addTranslation()">Add</button>
                    </div>-->
                </div>
                <!--<div class="btn-group-sm">
                    <button class="btn btn-outline-primary btn-sm" [disabled]="saveInProgress" (click)="showAddTranslation = true">Add Translation</button>
                </div>-->
            </div>
        <!--</div>-->

        <div *ngIf="isImageThere(glossaryInfo.entry.context.media)" class="form-group row">
            <div class="col-md-12">
                <img class="card-glossary-image" *ngIf="isImageThere(glossaryInfo.entry.context.media)" src="{{ getImageSrc(glossaryInfo.entry.context.media) }}"/>
            </div>
        </div>

        <div class="form-group row">
            <div class="col-md-12">

                <label class="form-label" for="image">Image Filename (optional)</label>
                <textarea class="form-control" rows="2" cols="55" id="image" [(ngModel)]="glossaryInfo.entry.context.media"></textarea>
            </div>
        </div>


        <div class="col-md-12">
            <div *ngIf="showAddCredit()" class="form-group row">
                <label class="form-label" for="imageAttribution">Image credit attribution (optional):</label>
                <textarea class="form-control" rows="2" cols="55" id="imageAttribution" [(ngModel)]="imageCredit.attribution"></textarea>
                <label class="form-label" for="imageDescription">Image credit description (optional):</label>
                <textarea class="form-control" rows="2" cols="55" id="imageDescription" [(ngModel)]="imageCredit.description"></textarea>
            </div>
        </div>


        <div class="form-group row">
            <div class="col-md-12">
                    <label class="form-label" for="fact">Fact (optional)</label>
                    <textarea class="form-control" rows="2" cols="55" id="fact" [(ngModel)]="glossaryInfo.entry.fact.text"></textarea>
                </div>
        </div>



        <div class="form-group row">
            <div *ngIf="isNewEntry()" class="btn-group-sm col-md-12">
                <button class="btn btn-primary btn-sm" [disabled]="changeDisabled() || dataMissing()" (click)="save(true)">Save and Link</button>
                <button class="btn btn-secondary btn-sm" [disabled]="changeDisabled()" (click)="deleteGlossaryEntry()">Cancel</button>
            </div>
            <div *ngIf="isV1Entry()" class="btn-group-sm col-md-12">
                <span> This is a legacy V1 content entry which cannot be edited or deleted </span>
                <button class="btn btn-primary btn-sm" [disabled]="changeDisabled()" (click)="addAsDefinition()">{{glossaryInfo.isDefinition ? 'Unlink' : 'Link'}}</button>
            </div>
            <div *ngIf="!isV1Entry() && !isNewEntry()" class="btn-group-sm col-md-12">
                <button class="btn btn-primary btn-sm" [disabled]="changeDisabled()" (click)="save(false)">Update</button>
                <button class="btn btn-primary btn-sm" [disabled]="changeDisabled()" (click)="addAsDefinition()">{{glossaryInfo.isDefinition ? 'Unlink' : 'Link'}}</button>
                <button *ngIf="!glossaryInfo.isDefinition" class="btn btn-danger btn-sm" [disabled]="changeDisabled()" (click)="deleteGlossaryEntry()">Delete</button>
            </div>
        </div>
    </div>
</div>
